import { invalidateAuthSession } from './authSession'

let failurePromise = null

export const resetAuthenticationFailure = () => {
  failurePromise = null
}

export const handleAuthenticationFailure = ({ clear, navigate }) => {
  if (failurePromise) return failurePromise

  invalidateAuthSession()
  clear()
  failurePromise = Promise.resolve().then(navigate).catch(() => undefined)
  return failurePromise
}



// WEBPACK FOOTER //
// ./src/auth/authenticationFailure.js